exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onboarding-wrapper{\n    width: 500px;\n    margin: auto;\n    text-align: center;\n    display: none;\n}\n\n.question{\n    display: none;\n}\n\n.open-question{\n    display: inline;\n}\n\n.show-onboarding{\n    display: inline;\n}\n\n#ob-progress-bar{\n    width: 50%;\n    margin: auto;\n}\n\n.img-container{\n    width: 90%;\n    margin: auto;\n    margin-bottom: 30px;\n    margin-top: 30px;\n}\n\n.img{\n    width: 33%;\n    margin: auto;\n}\n\n.gif-container{\n    width: 560px;\n    margin: auto;\n    margin-bottom: 30px;\n    margin-top: 30px;\n}\n\n.gif-container .gif{\n    width: 100%;\n}\n\n@media ( max-width: 767px ) {\n    .gif-container{\n        width: 95%;\n    }\n\n    .img{\n        width: 90%;\n        margin: auto;\n    }\n\n    .gif-container iframe { \n        height: 100%; \n        width: 100%;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/mmam/angular/src/app/onboarding/onboarding.component.css
// module id = ../../../../../src/app/onboarding/onboarding.component.css
// module chunks = main